module.exports = __webpack_public_path__ + "images/store_case_study/cowcowbookland-pic1_d629b0d5eb206ce6685de9c68470e377.jpg";